import { useState, useEffect, useCallback } from "react";
import moment from "moment";
import useConnect from "../../hooks/useConnect";
import {
  useClaim,
  useCurrentRewardEpoch,
  useNatPrice,
  useProviders,
  useClaimSetupManager,
  useDistributionToDelegators,
} from "../../hooks/useContracts";
import { ProviderProps } from "../../types";
import { notifyError } from "../../lib";
import flareSvg from "../../assets/FLR.svg";
import wrapflareSvg from "../../assets/WFLR.svg";
import ToggleBtn from "../../components/ToggleBtn";
import ExecutorsModal from "./components/ExecutorsModal";
import { DropDates } from "../../config/drop_date";
import { UnknownProvider } from "../../config/providers";

export const Rewards = () => {
  const { connect, chainId, account, active } = useConnect();
  const { epoch, startTime, duration, currentTime } = useCurrentRewardEpoch();
  const {
    claim,
    pending,
    unclaimed,
    claimable,
    dataProviderRewardsStatus,
  } = useClaim();
  const { claimExecutors, setClaimExecutor, claimExecutorsList } = useClaimSetupManager();
  const { claimableFlareToken, claimAllFlareDrop, claimableFlareDropMonths, currentMon } = useDistributionToDelegators();
  const { price } = useNatPrice();
  const providers: ProviderProps[] = useProviders();
  const [remain, setRemain] = useState(0);
  const [total, setTotal] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [isWrap, setIsWrap] = useState(false);
  const [isWrapFlareDrop, setIsWrapFlareDrop] = useState(false);
  useEffect(() => {
    let temp = 0;
    for (let i = 0; i < dataProviderRewardsStatus.length; i++) {
      temp += dataProviderRewardsStatus[i].amount;
    }
    setTotal(temp);
    temp = 0;
  }, [dataProviderRewardsStatus]);

  useEffect(() => {
    if (startTime < 1 || duration < 1) return;
    setRemain(moment((startTime + duration) * 1000).diff(moment()) / 1000);
  }, [startTime, duration]);

  const setTurnStatus = (val: boolean) => {
    if (val) setShowModal(val)
    else { setClaimExecutor([], 0) }
  }

  const coin = (chainId === 19 ? "SGB" : (chainId === 14 ? "FLR" : "C2FLR"));
  const wcoin = (chainId === 19 ? "WSGB" : chainId === 14 ? "WFLR" : "C2WFLR");

  return (
    <>
      <div className="grid grid-cols-1 gap-5 backdrop-blur-sm">
        <div className="rounded-[24px] bg-[#202231] shadow-dark-1000 shadow-md px-3  py-1  w-[90%] sm:w-[320px] md:w-96 mx-auto">
          <div className="p-2">
            <span className="text-base leading-5 cursor-pointer select-none text-secondary hover:text-white text-high-emphesis">
              Rewards
            </span>
            <div className="my-4 p-4 border rounded-[14px] border-gray-700 hover:border-gray-800 dark:hover:border-gray-600 bg-white dark:bg-[#161622] ">
              <div className="w-full text-sm text-gray-400 dark:text-gray-300">
                <div className="flex justify-between">
                  <span>Epoch Earnings:</span>
                  <span className="text-gray-400 uppercase">
                    {pending.toFixed(2)} {coin}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>Claimable:</span>
                  <span className="text-gray-400 uppercase">
                    {unclaimed.toFixed(2)} {coin}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span>Next Claim: </span>
                  <span className="text-gray-400">
                    {startTime === 0 || duration === 0
                      ? "0h 0m 0s"
                      : `${Math.floor(remain / (24 * 3600))}d
											${Math.floor((remain % (24 * 3600)) / 3600)}h
											${Math.floor((remain % 3600) / 60)}m
										`}
                  </span>
                </div>
              </div>
            </div>
            <div className="">
              {dataProviderRewardsStatus.map((item, index) => {
                return (
                  <div key={index} className="">
                    {item.epoch !==
                      dataProviderRewardsStatus[index - 1]?.epoch ? (
                      item.epoch === epoch ? (
                        <div className="pb-0 mt-6">
                          {`Current Epoch (${epoch})`}{" "}
                        </div>
                      ) : (
                        <div className="pb-0 mt-6">
                          {item.epoch === epoch - 1
                            ? `Previous Epoch (${epoch - 1})`
                            : `Epoch (${item.epoch})`}
                        </div>
                      )
                    ) : (
                      <></>
                    )}
                    <div className="flex items-center justify-between border rounded-[14px] border-gray-600  px-4 py-2 hover:bg-gray-50 dark:hover:bg-slate-700 dark:hover:border-gray-600 dark:bg-[#161622] cursor-pointer select-none mb-2">
                      <div className="flex items-center tracking-tight text-gray-200">
                        <img
                          src={
                            providers.filter((fpvd) => {
                              return fpvd.address === item.address;
                            })[0]?.logoURI ?? UnknownProvider.logoURI
                          }
                          className="w-6 mr-4"
                          alt=""
                        />
                        <span className="">
                          {
                            providers.filter((fpvd) => {
                              return fpvd.address === item.address;
                            })[0]?.name ?? UnknownProvider.name
                          }
                        </span>
                      </div>
                      <div className="text-sm text-gray-400">
                        {`${item.amount.toFixed(2)} ${coin}`}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="mb-4">
              <div className="flex justify-between w-full pt-2 mt-4 text-gray-400 border-t border-gray-700 dark:border-gray-700 hover:border-gray-800 dark:hover:border-gray-600">
                <div className="">Growing:</div>
                <div className="">
                  <span>{pending.toFixed(2)} </span>
                  <span className="text-sm uppercase ">{coin}</span>
                  {price ? (
                    <>
                      <span> | </span>
                      <span className="">
                        ${(pending * price * Math.pow(10, -5)).toFixed(2)}{" "}
                      </span>
                      <span className="text-sm uppercase">usd</span>
                    </>
                  ) : null}
                </div>
              </div>
              <div className="flex justify-between w-full pt-2 mt-4 text-gray-400 border-t border-gray-700 dark:border-gray-700 hover:border-gray-800 dark:hover:border-gray-600">
                <div className="">Claimable:</div>
                <div className="">
                  <span>{unclaimed.toFixed(2)} </span>
                  <span className="text-sm uppercase ">{coin}</span>
                  {price ? (
                    <>
                      <span> | </span>
                      <span className="">
                        ${(unclaimed * price * Math.pow(10, -5)).toFixed(2)}{" "}
                      </span>
                      <span className="text-sm uppercase">usd</span>
                    </>
                  ) : null}
                </div>
              </div>
              <div className="flex justify-between w-full pt-2 mt-4 text-gray-400 border-t border-gray-700 dark:border-gray-700 hover:border-gray-800 dark:hover:border-gray-600">
                <div className="">Total:</div>
                <div className="">
                  <span>{total.toFixed(2)} </span>
                  <span className="text-sm uppercase ">{coin}</span>
                  {price ? (
                    <>
                      <span> | </span>
                      <span className="">
                        ${(total * price * Math.pow(10, -5)).toFixed(2)}{" "}
                      </span>
                      <span className="text-sm uppercase">usd</span>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
            <div className="pb-2">
              <div className="items-center gap-2 flext">
                {account && active ? (
                  unclaimed !== 0 ? (
                    claimable === false ? (
                      <div className="text-center text-gray-500 border rounded-[14px] border-gray-700 bg-white dark:bg-[#161622]  px-3 py-1">
                        <span>
                          Claim in{" "}
                          {startTime === 0 || duration === 0
                            ? "0h 0m 0s"
                            : `${Math.floor(remain / (24 * 3600))}d
											${Math.floor((remain % (24 * 3600)) / 3600)}h
											${Math.floor((remain % 3600) / 60)}m
										`}
                        </span>
                      </div>
                    ) : (
                      <div className="flex justify-between">
                        <div className="flex my-auto">

                          <button className="bg-[#DAA520] py-1 px-2 rounded-[12px] w-24 sm:w-32 md:w-36" onClick={() => claim(isWrap)}>
                            <span>Claim Rewards</span>
                          </button>
                          {/* <div className="mb-[0.125rem] my-auto mx-2 block min-h-[1.5rem] pl-[1.5rem]">
                            <input
                              className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                              type="checkbox"
                              value=""
                              id="checkboxDefault" checked={isWrap} onChange={(e) => setIsWrap(!isWrap)} />
                            <label
                              className="inline-block pl-[0.15rem] hover:cursor-pointer"
                              htmlFor="checkboxDefault">
                              Wrap
                            </label>
                          </div> */}
                        </div>
                        <div className="text-right">
                          <ToggleBtn isTurn={claimExecutors.length !== 0} setTurnStatus={setTurnStatus} />
                          <span className="text-[12px]">Auto Claim</span>
                        </div>
                      </div>
                    )
                  ) : (
                    <div className="text-center flex justify-between">
                      <div className="">
                        <button className="text-center border border-gray-700 hover:border-gray-800 dark:hover:border-gray-600 bg-white dark:bg-[#161622] dark:hover:bg-[#202231] py-1 px-2 rounded-[12px] w-24 sm:w-32 md:w-36">
                          <span>No rewards</span>
                        </button>
                      </div>
                      <div className="text-right">
                        <ToggleBtn isTurn={claimExecutors.length !== 0} setTurnStatus={setTurnStatus} />
                        <span className="text-[12px]">Auto Claim</span>
                      </div>
                    </div>
                  )
                ) : (
                  <div
                    className="text-center rounded-[14px] dark:bg-[#DAA520] px-3 py-2 cursor-pointer"
                    onClick={() => {
                      if (!active) {
                        connect().catch((e) => {
                          if (e.name === "UnsupportedChainIdError") {
                            notifyError("Please connect to Songbird or Flare");
                          }
                        });
                      }
                    }}
                  >
                    <span>Connect Wallet</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {(chainId == 14 || chainId === 114) && <div className="rounded-[14px] bg-[#202231] shadow-dark-1000 shadow-md px-3  py-2 mt-4 w-[90%] sm:w-[320px] md:w-96 mx-auto">
          <div className="flex px-2 pt-2">
            <div className="mr-2">
              <img src={flareSvg} alt="provider logo" className="w-[40px] h-[40px]" />
            </div>
            <div className="flex flex-col justify-center">
              <h4 className="text-[22px]">FlareDrops</h4>
            </div>
          </div>
          <div className="p-2">
            <p className="text-[14px]">
              By wrapping and delegating FLR to FTSOs you will receive bonus airdrops of FLR from the Flare Foundation for the next 36 months. This widget helps you Claim and Wrap your FLR airdrops!
            </p>
          </div>
          <div className="rounded-[14px] text-[14px] text-start p-3 border border-gray-700 hover:border-gray-600 bg-[#161622]">
            {/* <p>Total Claimed: <mark className="text-[#E9B83B] bg-transparent">{totalCalimedFlareDrop}</mark></p> */}
            <p>Next Drop: <mark className="text-[#E9B83B] bg-transparent">{(currentMon && (currentMon < 36)) ? DropDates[currentMon] : "No Drop"}</mark></p>
            {/* <p>Unclaimed: <mark className="text-[#E9B83B] bg-transparent">10,000FLR</mark></p> */}
            <p>Claimable: <mark className="text-[#E9B83B] bg-transparent">{claimableFlareToken.toFixed(2)}FLR</mark></p>
            <p>Current Month: <mark className="text-[#E9B83B] bg-transparent">{currentMon}</mark></p>
          </div>
          <div className="text-center flex justify-between mt-[20px]">
            <div className="flex my-auto">
              <button className="bg-[#DAA520] py-1 px-2 rounded-[12px] w-24 sm:w-32 md:w-36 disabled:opacity-[40%]" disabled={claimableFlareToken == 0} onClick={() => claimAllFlareDrop(isWrapFlareDrop)}>
                <span>Claim</span>
              </button>
              <div className="mb-[0.125rem] my-auto mx-2 block min-h-[1.5rem] pl-[1.5rem]">
                <input
                  className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                  type="checkbox"
                  value=""
                  id="checkboxDefault1" checked={isWrapFlareDrop} onChange={(e) => setIsWrapFlareDrop(!isWrapFlareDrop)} />
                <label
                  className="inline-block pl-[0.15rem] hover:cursor-pointer"
                  htmlFor="checkboxDefault1">
                  Wrap
                </label>
              </div>
            </div>
            <div className="text-right">
              <ToggleBtn isTurn={claimExecutors.length !== 0} setTurnStatus={setTurnStatus} />
              <span className="text-[12px]">Auto Claim</span>
            </div>
          </div>
        </div>}
      </div>
      <ExecutorsModal
        onClose={() => setShowModal(false)}
        isOpen={showModal}
        items={claimExecutorsList}
        setting={setClaimExecutor}
      >
      </ExecutorsModal>
    </>
  );
};
